/**
 * The props type of a TanStack Form `withForm` component. `withForm` only
 * reads the type of its `props` option and never the value, and TanStack's
 * documented idiom is `props: {} as Props` — that one assertion lives here,
 * instead of once per form section.
 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- T is the whole point: a type-only carrier
export function formProps<T>(): T {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- never read at runtime, see above
  return {} as T;
}
